<template>
  <div v-if="currentUser" class="client-contact-listing">
    <ClientContactsFilter @change="onFilterChange" />
    <ClientContactsActions />
    <tol-table
      :table-data="clientContacts"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'clientContactName' ? currentSortDirection : 'none'"
          field-name="clientContactName"
          @change="onSortOrderChange"
          >{{ $t('clientContacts.listing.labels.clientContactName') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'client' ? currentSortDirection : 'none'"
          field-name="client"
          @change="onSortOrderChange"
          >{{ $t('clientContacts.listing.labels.client') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'email' ? currentSortDirection : 'none'"
          field-name="email"
          @change="onSortOrderChange"
          >{{ $t('clientContacts.listing.labels.email') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'phone1' ? currentSortDirection : 'none'"
          field-name="phone1"
          @change="onSortOrderChange"
          >{{ $t('clientContacts.listing.labels.phone') }}</th-sortable
        >
      </template>

      <template v-slot:reference_number="{ value }">
        <router-link :to="value.reference_number">{{ value.reference_number }}</router-link>
      </template>
    </tol-table>

    <Pagination
      :records-per-page="ClientContactsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';
import {
  ClientContactsListingGetters,
  ClientContactsListingActions
} from './client-contacts-listing.keys';
import ClientContactsActions from './components/ClientContactsActions';
import ClientContactsFilter from './components/ClientContactsFilter';
import { AppActions } from '@/app/app.keys';
export default {
  components: { TolTable, ThSortable, Pagination, ClientContactsActions, ClientContactsFilter },
  computed: {
    clientContacts() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsList];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    columns() {
      return ['clientContactName', 'client', 'email', 'phone1'];
    },
    currentSortField() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListSortBy];
    },
    currentSortDirection() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListSortDirection];
    },
    ClientContactsPerPage() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsPerPage];
    },
    currentPage() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListingOffset];
    },
    recordCount() {
      return this.$store.getters[ClientContactsListingGetters.ClientContactsListingRecordCount];
    }
  },

  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('clientContacts.listing.labels.title'));
    this.$store.dispatch(ClientContactsListingActions.RetrieveContactsList);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(ClientContactsListingActions.UpdateClientContactsSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(ClientContactsListingActions.UpdatePaginationParams, event);
    },
    onFilterChange(activeInactive) {
      this.$store.dispatch(ClientContactsListingActions.UpdateActiveInactive, activeInactive);
    },
    handleRowClick(evt) {
      this.$router.push(`/client-contacts/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.client-contact-listing {
  list-style-position: inside;
  padding-left: 0;
}
</style>
